
import React from 'react';
import { useLanguage } from '../contexts/language';
import { Button } from '@/components/ui/button';
import { Languages } from 'lucide-react';
import { useIsMobile } from '../hooks/use-mobile';

const LanguageToggle: React.FC = () => {
  const { language, toggleLanguage } = useLanguage();
  const { isMobile } = useIsMobile();
  
  return (
    <Button 
      variant="outline" 
      size={isMobile ? "sm" : "sm"}
      className="flex items-center gap-2 bg-white/10 text-white border-white/20 hover:bg-white/20 hover:text-white"
      onClick={toggleLanguage}
    >
      <Languages className="h-4 w-4" />
      <span className={isMobile ? "hidden" : ""}>
        {language === 'en' ? '🇺🇸 English' : '🇲🇽 Español'}
      </span>
      <span className={isMobile ? "" : "hidden"}>
        {language === 'en' ? '🇺🇸' : '🇲🇽'}
      </span>
    </Button>
  );
};

export default LanguageToggle;
